import axios from 'axios';
import Config from 'src/config';
import { authHeaders } from 'src/actions/authHeaders';

// --- Produtos ---

export const v2_actionListarProdutos = (ownerId) => {
    return axios({
        headers: authHeaders(),
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products?ownerId=${ownerId}`
    });
};

export const v2_actionCriarProduto = (data) => {
    // Enforce ownerId is string if not present
    if (!data.ownerId && data.cliente?._id) data.ownerId = data.cliente._id;

    return axios({
        headers: authHeaders(),
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products`,
        data: data
    });
};

export const v2_actionEditarProduto = (id, data) => {
    return axios({
        headers: authHeaders(),
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/${id}`,
        data: data
    });
};

export const v2_actionDeletarProduto = (id) => {
    return axios({
        headers: authHeaders(),
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/${id}`
    });
};

export const v2_actionObterProduto = (id) => {
    return axios({
        headers: authHeaders(),
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/${id}`
    });
};

export const v2_actionVerificarSkuExiste = (ownerId, sku, excludeProductId = null) => {
    let url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/check-sku?ownerId=${ownerId}&sku=${encodeURIComponent(sku)}`;
    if (excludeProductId) {
        url += `&excludeProductId=${excludeProductId}`;
    }
    return axios({
        headers: authHeaders(),
        method: "get",
        url
    });
};

export const v2_actionContarProdutos = (ownerId) => {
    return axios({
        headers: authHeaders(),
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/count?ownerId=${ownerId}`
    });
};


export const v2_actionImportarProdutos = (formData) => {
    return axios({
        headers: authHeaders(),
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/import`,
        data: formData,
        headers: authHeaders({ "Content-Type": "multipart/form-data" })
    });
};

// --- Categorias ---

export const v2_actionListarCategorias = (ownerId) => {
    return axios({
        headers: authHeaders(),
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/categories?ownerId=${ownerId}`
    });
};

export const v2_actionCriarCategoria = (data) => {
    return axios({
        headers: authHeaders(),
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/categories`,
        data: data
    });
};

export const v2_actionEditarCategoria = (id, data) => {
    return axios({
        headers: authHeaders(),
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/categories/${id}`,
        data: data
    });
};

export const v2_actionDeletarCategoria = (id) => {
    return axios({
        headers: authHeaders(),
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/categories/${id}`
    });
};
